import { setCredentials, setPermissions, logoutAuth, setDeviceIdAction, UserRole } from "./authSlice";
import { loginOwner, logoutOwner, ProviderType } from "./ownerSlice";
import { loginStore, logoutStore } from "./storeSlice";
import { loginAdmin, logoutAdmin, updatePermiossions } from "./adminSlice";
import { loginOrganizer, logoutOrganizer } from "./organizerSlice";
import { loginCustomer, logoutCustomer } from "./customerSlice";
import { loginOrganization, logoutOrganization } from "./organizationSlice";
import { PermissionsKey } from "../data/permissions";
import { Store } from "../types/modules/store.type";
import { Organization } from "../types/modules/organization.type";
import { AppDispatch } from "./store";
import { setAccessToken, getDeviceId } from "../api/token";
import api from "../api/apiClient";



export const adaptOwnerLogin = (
    payload: { accessToken: string; currentIntegrationId?: number | null; provider?: ProviderType }
) => (dispatch: AppDispatch) => {
    const deviceId = getDeviceId();
    dispatch(setCredentials({ accessToken: payload.accessToken, role: "OWNER" }));
    dispatch(setDeviceIdAction({ deviceId }));
    setAccessToken(payload.accessToken);
    dispatch(loginOwner({ accessToken: payload.accessToken, currentIntegrationId: payload.currentIntegrationId, provider: payload.provider }));
};

export const adaptStoreLogin = (
    payload: { accessToken: string; store: Store }
) => (dispatch: AppDispatch) => {
    const deviceId = getDeviceId();
    dispatch(setCredentials({ accessToken: payload.accessToken, role: "STORE" }));
    dispatch(setDeviceIdAction({ deviceId }));
    setAccessToken(payload.accessToken);
    dispatch(loginStore({ accessToken: payload.accessToken, store: payload.store }));
};

export const adaptAdminLogin = (
    payload: { accessToken: string; permissions: PermissionsKey[] }
) => (dispatch: AppDispatch) => {
    const deviceId = getDeviceId();
    dispatch(setCredentials({ accessToken: payload.accessToken, role: "ADMIN" }));
    dispatch(setPermissions({ permissions: payload.permissions }));
    dispatch(updatePermiossions({ permissions: payload.permissions }));
    dispatch(setDeviceIdAction({ deviceId }));
    setAccessToken(payload.accessToken);
    dispatch(loginAdmin({ accessToken: payload.accessToken, permissions: payload.permissions }));
};

export const syncAdminPermissions = () => async (dispatch: AppDispatch) => {
    const response = await api.get<{ permissions: PermissionsKey[] }>("admin/permissions");
    const permissions = response?.data?.permissions ?? [];

    dispatch(setPermissions({ permissions }));
    dispatch(updatePermiossions({ permissions }));
};

export const adaptOrganizerLogin = (
    payload: { accessToken: string }
) => (dispatch: AppDispatch) => {
    const deviceId = getDeviceId();
    dispatch(setCredentials({ accessToken: payload.accessToken, role: "ORGANIZER" }));
    dispatch(setDeviceIdAction({ deviceId }));
    setAccessToken(payload.accessToken);
    dispatch(loginOrganizer({ accessToken: payload.accessToken }));
};

export const adaptCustomerLogin = (
    payload: { accessToken: string }
) => (dispatch: AppDispatch) => {
    const deviceId = getDeviceId();
    dispatch(setCredentials({ accessToken: payload.accessToken, role: "CUSTOMER" }));
    dispatch(setDeviceIdAction({ deviceId }));
    setAccessToken(payload.accessToken);
    dispatch(loginCustomer({ accessToken: payload.accessToken }));
};

export const adaptOrganizationLogin = (
    payload: { accessToken: string; organization: Organization }
) => (dispatch: AppDispatch) => {
    const deviceId = getDeviceId();
    dispatch(setCredentials({ accessToken: payload.accessToken, role: "ORGANIZATION" }));
    dispatch(setDeviceIdAction({ deviceId }));
    setAccessToken(payload.accessToken);
    dispatch(loginOrganization({ accessToken: payload.accessToken, organization: payload.organization }));
};


export const adaptLogoutAll = () => (dispatch: AppDispatch) => {
    const performServerLogout = async () => {
        try {
            await api.post("/user-token/logout-current-device", {
                deviceId: getDeviceId(),
            });
        } catch (error) {
        }
    };

    performServerLogout();

    dispatch(logoutAuth());
    setAccessToken(null);

    dispatch(logoutOwner());
    dispatch(logoutStore());
    dispatch(logoutAdmin());
    dispatch(logoutOrganizer());
    dispatch(logoutCustomer());
    dispatch(logoutOrganization());
};

export const adaptTokenRefresh = (
    payload: { accessToken: string; role: Exclude<UserRole, null> }
) => (dispatch: AppDispatch) => {
    dispatch(setCredentials({ accessToken: payload.accessToken, role: payload.role }));
    setAccessToken(payload.accessToken);
};